<template>
    <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-center justify-center min-h-screen p-4">
            <div class="bg-white w-full max-w-md rounded-lg shadow-xl p-6 relative">
                <button
                    @click="closeModal"
                    class="absolute top-2 right-2 text-gray-600 hover:text-gray-800 focus:outline-none"
                >
                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <h3 class="text-2xl font-semibold text-gray-800 mb-4">
                    Change Status
                </h3>
                <div v-if="application">
                    <div class="mb-4">
                        <label for="status" class="block text-gray-700 text-sm font-bold mb-2">New Status</label>
                        <select  :value="newStatusComputed" @input="newStatusComputed = $event.target.value"  id="status" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                            <option v-if="application.status !== 'Evaluar'" value="Evaluar">📊 Evaluar</option>
                           <option v-if="application.status !== 'Reclutador'" value="Reclutador"> 📅 Reclutador</option>
                            <option v-if="application.status !== 'Proceso'" value="Proceso"> 📝 Proceso</option>
                            <option v-if="application.status !== 'Seleccionado'" value="Seleccionado"> 🏆 Seleccionado</option>
                            <option value="Descartado"> ❌ Descartado</option>
                        </select>
                    </div>
                     <div class="mb-4">
                           <label for="notes" class="block text-gray-700 text-sm font-bold mb-2">Notes</label>
                        <textarea
                           v-model="notesComputed"
                             id="notes"
                             rows="4"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         />
                    </div>
                      <div class="mb-4" v-if="application.statusHistory && application.statusHistory.length > 0">
                          <h4 class="text-lg font-semibold text-gray-700 mb-2">Status History</h4>
                            <div v-for="(historyItem, index) in application.statusHistory" :key="index" class="mb-2">
                                <p class="text-gray-600">
                                 <strong>{{ historyItem.status }} </strong> -
                                    {{ new Date(historyItem.date._seconds * 1000).toLocaleString() }}
                                  </p>
                                   <p class="text-gray-600">
                                       {{ historyItem.notes }}
                                   </p>
                             </div>
                       </div>
                     <button @click="updateStatus" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                             Update Status
                     </button>
                </div>
                 <div v-else>
                      <p class="text-gray-700 mb-2">Application information not available.</p>
                 </div>
             </div>
       </div>
  </div>
</template>

<script>
import { auth } from '@/firebase';
export default {
    props: {
        isOpen: Boolean,
        application: Object,
    },
     data() {
        return {
            notes: "",
           newStatus: null,
         };
   },
     computed: {
        newStatusComputed: {
            get() {
                return this.newStatus || this.getNextStatus();
            },
             set(value) {
                this.newStatus = value;
            }
        },
       notesComputed: {
            get() {
                 return this.notes || "";
            },
           set(value){
               this.notes = value
           }
        }
    },
    methods: {
        getNextStatus() {
           if (!this.application) {
              return null;
            }
          if (this.application.status === 'Descartado') {
               return "Descartado";
          }
      const statusOrder = ['Nueva', 'Entrevista', 'Evaluar', 'Reclutador', 'Proceso', 'Seleccionado', 'Descartado'];
          const currentStatusIndex = statusOrder.indexOf(this.application.status);
          if (currentStatusIndex === -1 || currentStatusIndex === statusOrder.length - 1) {
                return statusOrder[0]; // Si no se encuentra el estado o está al final, se regresa al inicial
           }
           return statusOrder[currentStatusIndex + 1];
    },
       async updateStatus() {
          try {
             const token = await auth.currentUser.getIdToken();

              const response = await fetch('/api/update-application-status', {
                   method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                 },
                   body: JSON.stringify({
                         applicationId: this.application.id,
                           newStatus: this.newStatusComputed,
                            notes: this.notesComputed,
                            interviewId: this.application.interviewId
                 }),
            });

            if (!response.ok) {
                  const errorData = await response.json();
                     throw new Error(
                         `Failed to update application status: ${response.status} ${JSON.stringify(errorData)}`
                    );
               }

              this.$emit("close");
                this.$emit("status-updated");
            } catch(error){
                console.error("Error updating application status", error)
               alert("Error updating application status")
            }
     },
       closeModal() {
            this.notes= ""; //Clear the local notes, each time the modal is closed
            this.$emit("close");
        },
    },
};
</script>